import {
  postObjectToStreamhubContact
} from '../../common/streamHub';
import {
  ConsentHubClient as Client,
  ConsentHelper
} from '../../common/ConsentHubV2';
import Environment from "../../common/environment";

import tracking from '../../utils/tracking';

const emailRegex = /@(gmail\.|yahoo\.|aol\.|comcast\.net|hotmail\.|ymail\.|msn\.|mac\.|sina\.|freemail\.|me\.|icloud\.|live\.|gnail\.|gmsil\.|gmial\.|gamil\.|gail\.)/;
const defaultEmailPattern = /([\w\.\+\-]+)@(\[(\d{1,3}\.){3}|(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,15}|\d{1,3})(\]?)/;
const defaultBusinessEmailPattern = /([\w\.\+\-]+)@(\[(\d{1,3}\.){3}|(?!(gmail\.)|(yahoo\.)|(aol\.)|(comcast\.net)|(hotmail\.)|(ymail\.)|(msn\.)|(mac\.)|(sina\.)|(freemail\.)|(me\.)|(icloud\.)|(live\.)|(gnail\.)|(gmsil\.)|(gmial\.)|(gamil\.)|(gail\.))(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,15}|\d{1,3})(\]?)/;
let isFormChecking = false;
let isKeying = false;

export default class ContactSalesForm {
  domRoot: HTMLElement;
  params: any;
  consentKey: any;
  privacyPolicyText: any;
  consentCheckboxText: any;
  consentConfigInfo: {};
  activeForm: HTMLFormElement;
  errorSubmit: any;
  ConsentHub: Client;
  consents: NodeListOf<Element>;
  consentCheckboxes: NodeListOf<Element>;
  errorMessages: any;
  referrers: any;
  referringURL: string;
  contactForms: HTMLFormElement[];
  availableFormTypes: any;
  availableFormTypeLabels: any;
  typeOfForm: any;
  urlParams: URLSearchParams;
  urlFormType: any;
  tabs: NodeListOf<Element>;
  fauxSelectors: NodeListOf<Element>;
  productServiceInputs: NodeListOf<Element>;
  textAreas: NodeListOf<HTMLTextAreaElement>;
  numberInputs: NodeListOf<Element>;
  plainOptions: NodeListOf<Element>;
  productOrService: any;
  productOrServiceTogglers: NodeListOf<Element>;
  submitTo: any;
  formId: any;
  formDef: any;
  isIntercomTracking: boolean;
  isBusinessDomainOnly?: boolean;
  intercomAppId: any;
  postSubmission: any;
  redirect: any;
  form: any;
  mainFormContainer: any;
  postSubmitMessage: any;
  emailFields: NodeList<Element>;
  consentHelper: {};

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = domRoot;
    this.params = params;
    this.consentKey = params.consentType;
    this.privacyPolicyText = params.privacyPolicyText;
    this.consentCheckboxText = params.consentCheckboxText;
    this.consentConfigInfo = {};
    this.activeForm = domRoot.querySelector('form') as HTMLFormElement;
    this.errorSubmit = params.errorSubmit;
    this.ConsentHub = new Client();
    this.consents = domRoot.querySelectorAll('.consent-checkbox-container');
    this.consentCheckboxes = domRoot.querySelectorAll('.consent-checkbox');
    this.errorMessages = params.errorMessages;
    this.referrers = params.referrers;
    this.referringURL = document.referrer.replace(/#(.*?)/, '').replace(/\?(.*?)/, '');
    this.contactForms = Array.from(domRoot.querySelectorAll("form"));
    this.availableFormTypes = params.formTypes;
    this.availableFormTypeLabels = params.formTypeLabels;
    this.typeOfForm = domRoot.querySelector(".formTypeSelector");
    this.urlParams = new URLSearchParams(window.location.search.substring(1));
    this.urlFormType = this.urlParams.get("formType");
    this.tabs = domRoot.querySelectorAll('.tab-multi-popper');
    this.fauxSelectors = domRoot.querySelectorAll(".faux-selector select");
    this.productServiceInputs = domRoot.querySelectorAll(".radio-labels input");
    this.textAreas = domRoot.querySelectorAll('textarea');
    this.numberInputs = domRoot.querySelectorAll('input[type="number"]');
    this.plainOptions = domRoot.querySelectorAll(".plain-radio, .plain-checkbox");
    this.productOrService = domRoot.querySelector("#productInterest__c");
    this.productOrServiceTogglers = domRoot.querySelectorAll(".select-style-input");
    this.submitTo = params.submitTo;
    this.formId = params.formId;
    this.formDef = params.formDef;
    this.isIntercomTracking = this.params.isIntercomTracking.toLowerCase() === "true";
    this.isBusinessDomainOnly = this.params.isBusinessDomainOnly.toLowerCase() === "true";
    this.intercomAppId = params.intercomAppId;
    this.postSubmission = this.params.postSubmission;
    this.redirect = this.params.redirect;
    this.form = domRoot.querySelector('.form--contact-sales-form');
    this.mainFormContainer = domRoot.querySelector('.main-form-container');
    this.postSubmitMessage = domRoot.querySelector('.form--contact-sales-form__message');
    this.emailFields = domRoot.querySelectorAll('input[type="email"]');
    this.consentHelper = {};
    this.init();
  }

  init() {
    this.getConsentInfo();
    this.getUserData();   
    this.formSubmitListener();
    this.tabsListener();
    this.productTogglersListener();
    this.fauxSelectorsListener();
    this.plainListeners();
    this.routeToForm();
    this.addMunchkin();
    this.setFieldValidity();
    this.setFieldValidityForCheckBoxes();
    this.setEmailFieldValidity();

    window.addEventListener("beforeunload", () => {
      this.clearForm();
    });

  }

  addMunchkin() {
    const orgIdSandBox = "353-DGC-691";
    const orgIdProd = "594-ATC-127";
    const isProd = window.location.hostname.match(/^(www\.){0,1}(atlassian.com|bitbucket.org|opsgenie.com|bitbucket.org|trello.com)$/);

    let didInit = false;

    function initMunchkin() {
      if (didInit === false) {
        didInit = true;
        Munchkin.init(isProd ? orgIdProd : orgIdSandBox);
      }
    }
    const s = document.createElement("script")
    s.type = "text/javascript";
    s.async = true;
    s.src = "//munchkin.marketo.net/munchkin.js";
    s.onreadystatechange = function () {
      if (this.readyState == "complete" || this.readyState == "loaded") {
        initMunchkin()
      }
    };
    s.onload = initMunchkin;
    document.getElementsByTagName("head")[0].appendChild(s);
  }

  routeToForm() {
    if (this.availableFormTypes.length > 1) {
      let referralFound = this.findReferrerInSites();
      let formTypeInput = this.domRoot.querySelector('option#formType-' + this.availableFormTypes[0]);

      if (this.urlFormType && this.availableFormTypes.includes(this.urlFormType)) {
        formTypeInput = this.domRoot.querySelector('option#formType-' + this.urlFormType);
      } else if (referralFound) {
        formTypeInput = this.domRoot.querySelector('option#formType-' + referralFound);
      }
      this.updateSelectorValue(formTypeInput.parentNode, formTypeInput);
    }
  }

  findReferrerInSites() {
    for (let formType in this.referrers) {
      let links = this.referrers[formType];
      for (let l = 0; l < links.length; l++) {
        let link = links[l].startsWith('http') ? links[l] : window.location.origin + links[l];
        if (link == this.referringURL) {
          return formType;
        }
      }
    }
    return false;
  }

  plainListeners() {
    this.plainOptions.forEach(plainOption => {
      plainOption.addEventListener("change", () => {
        this.setConditionalDisplays(plainOption.dataset.conditionalType, plainOption.dataset.conditional, !plainOption.checked);
      })
    });

    this.numberInputs.forEach(numberInput => {
      numberInput.addEventListener("mousewheel", (event) => {
        if (numberInput == document.activeElement) {
          event.preventDefault();
        }
      })
    });
    this.textAreas.forEach(textArea => {
      textArea.addEventListener("keyup", () => {
        let val = textArea.value;
        let lineBreaks = val.match(/[\n\r]/g) ? (val.match(/[\n\r]/g).length * 1.5) : 0;
        let minHeight = (val.length > 70 ? ((val.length / 70) * 2.5) : 4) + lineBreaks;
        textArea.style.minHeight = minHeight + 'rem';
      })
    })
  }

  /* faux selectors (custom selectors) */

  updateSelectorValue(selector: HTMLSelectElement, selectorOption?: HTMLOptionElement) {
    //selectorOption.parentNode.previousElementSibling.innerText = selectorOption.dataset.localizedValue;
    if (!selectorOption) {
      selectorOption = selector.options[selector.selectedIndex];
    }
    selector.value = selectorOption.value;
    if (selectorOption.hasAttribute('data-conditional')) {
      this.setConditionalDisplays(selectorOption.dataset.conditionalType, selectorOption.dataset.conditional);
    }

    if (selectorOption.attributes?.name?.value == "formType") {
      this.urlParams.delete("formType");
      const otherParams = this.urlParams.toString();
      history.replaceState({}, '', `?formType=${selectorOption.dataset.conditional}${otherParams.length ? '&' : ''}${otherParams}`);
      this.activeForm = this.domRoot.querySelector('#form-' + selectorOption.dataset.conditional);
    }
  }

  fauxSelectorsListener() {
    this.fauxSelectors.forEach((fauxSelector: HTMLSelectElement) => {
      fauxSelector.addEventListener("change", (_event) => {
        this.updateSelectorValue(fauxSelector);
        this.checkFormValidity();
      });
    });
  }

  /* custom product/service selector */

  toggleProductSelectionDropdown(optionsContainer, close?: boolean) {
    let productOrServiceToggler = optionsContainer.previousElementSibling;
    if (close) {
      productOrServiceToggler.classList.remove("toggled");
      productOrServiceToggler.setAttribute("aria-expanded", false);
      optionsContainer.classList.add("hiding");
      setTimeout(function () {
        optionsContainer.style.display = "none";
        productOrServiceToggler.focus();
      }, 500);
      isKeying = false;
    } else {
      productOrServiceToggler.classList.add("toggled");
      productOrServiceToggler.setAttribute("aria-expanded", true);
      optionsContainer.style.display = "block";
      let firstButton = optionsContainer.querySelector('button[aria-selected="true"]');
      firstButton.focus();
      setTimeout(function () {
        optionsContainer.classList.remove("hiding");
      }, 50)
    }
  }

  productTogglersListener() {
    this.productOrServiceTogglers.forEach(toggler => {
      let optionsContainer = toggler.nextElementSibling;

      toggler.addEventListener("click", () => {
        if (!optionsContainer.classList.contains("hiding")) {
          this.toggleProductSelectionDropdown(optionsContainer, true);
        } else {
          this.toggleProductSelectionDropdown(optionsContainer);
        }
      });

      toggler.addEventListener("keydown", (event) => {
        const keymatch = /ArrowDown|ArrowUp|Enter|Space/g;
        if (event.code.match(keymatch)) {
          this.toggleProductSelectionDropdown(optionsContainer);
        } else if (!optionsContainer.classList.contains("hiding") ||
          event.key == "Escape") {
          this.toggleProductSelectionDropdown(optionsContainer, true);
        }
      });
    });

    this.productServiceInputs.forEach(input => {
      let parentEl = input.closest(".product-or-service-toggler");
      let dropdown = input.closest(".multi-select-container");

      let productOrServiceToggler = parentEl.querySelector('.select-style-input');
      let actualValue = parentEl.querySelector('.actual-value');

      input.addEventListener("change", () => {
        productOrServiceToggler.value = input.dataset.localizedValue;
        productOrServiceToggler.innerText = input.dataset.localizedValue;
        actualValue.value = input.value;
        const e = new Event("change");
        actualValue.dispatchEvent(e);
        isKeying = false;
        this.setConditionalDisplays(input.dataset.conditionalType, input.dataset.conditional);
      });

      input.addEventListener("click", (event) => {
        if (!isKeying && event.clientX != 0 && event.clientY != 0) {
          this.toggleProductSelectionDropdown(dropdown, true);
        }
        isKeying = false;
      })

      input.addEventListener("keydown", (event) => {
        isKeying = true;
        if (event.key == "Enter" || event.key == "Escape") {
          event.preventDefault();
          input.blur();
          this.toggleProductSelectionDropdown(dropdown, true);
        }
      });

      input.addEventListener("blur", (event) => {
        if (!isKeying && !dropdown.contains(event.relatedTarget)) {
          this.toggleProductSelectionDropdown(dropdown, true);
        }
      })
    });
  }

  tabsListener() {
    this.tabs.forEach((thisTab, index) => {
      thisTab.addEventListener("click", () => {

        let siblingTabs = thisTab.parentNode.querySelectorAll('.tab-multi-popper')
        siblingTabs.forEach(tab => {
          tab.setAttribute("aria-selected", "false");
          tab.setAttribute("tabindex", "-1");
        });
        thisTab.setAttribute("aria-selected", "true");
        thisTab.setAttribute("tabindex", "0");
      });

      thisTab.addEventListener("keydown", event => {
        if (event.key.includes("Arrow")) {
          let siblingTabs = thisTab.parentNode.querySelectorAll('.tab-multi-popper')

          let newIndex = 1;
          if (index == 1) {
            newIndex = 0;
          }
          siblingTabs[index].setAttribute("aria-selected", "false");
          siblingTabs[index].setAttribute("tabindex", "-1");

          siblingTabs[newIndex].setAttribute("aria-selected", "true");
          siblingTabs[newIndex].setAttribute("tabindex", "0");
          siblingTabs[newIndex].focus();
        } else if (event.key == "Escape") {
          this.toggleProductSelectionDropdown(thisTab.closest('.multi-select-container'), true);
        }
      })
    });
  }

  /* other listeners */

  checkFormValidity() {
    isFormChecking = true;
    const submitButton = this.activeForm.querySelector('[type="submit"]');
    if (this.activeForm.checkValidity()) {
      // Check that submit button exists (and not "Contact Support" link)
      if (submitButton) {
        submitButton.className = submitButton.dataset.buttonStyle;
      }
    } else {
      submitButton.className = 'component__link custom button button--regular n30 hover-n40 text-n600 border-color-default';
    }
    setTimeout(function () {
      isFormChecking = false;
    }, 50)
  }

  clearError(event) {
    let allFields = [event.target];
    const plainRegex = /select|radio|checkbox/;

    if (event.target.type.match(plainRegex) && event.target.className.includes("plain")) {
      allFields = document.querySelectorAll(`[name="${event.target.name}"]`)
    }
    allFields.forEach(field => {
      let fieldIdentifier = field.type.match(plainRegex) ? field.name : field.id;
      let fieldError = document.getElementById(fieldIdentifier + "-description");
      if (fieldError) {
        fieldError.innerText = "";
        fieldError.classList.remove("error");
      }
      field.setCustomValidity("");
    });
    this.checkFormValidity();
  }

  messageError(event: Event, forceEmailPatternError?: boolean) {
    if (!isFormChecking && event.target) {
      let errMessage = '';

      let fieldIdentifier = event.target.className.includes("plain") ? event.target.name : event.target.id;
      let errorMessages = this.errorMessages[fieldIdentifier];
      let fieldError = document.getElementById(fieldIdentifier + "-description");

      if (event.target.validity.valueMissing) {
        errMessage = errorMessages.missing;
      } else if (event.target.validity.patternMismatch) {
        if (event.target.type == "email" && event.target.value.match(emailRegex)) {
          errMessage = errorMessages.email
        } else {
          errMessage = errorMessages.pattern;
        }
      } else if (event.target.validity.tooShort) {
        errMessage = errorMessages.tooShort ?? '';
      } else if (event.target.validity.tooLong) {
        errMessage = errorMessages.tooLong ?? '';
      } else if (event.target.validity.rangeOverflow) {
        errMessage = errorMessages.rangeOverflow ?? '';
      } else if (event.target.validity.rangeUnderflow) {
        errMessage = errorMessages.rangeUnderflow ?? '';
      }

      if(event.target.type == "email" && forceEmailPatternError) {
        if (event.target.type == "email" && event.target.value.match(emailRegex)) {
          errMessage = errorMessages.email
        } else {
          errMessage = errorMessages.pattern;
        }
      }

      fieldError.innerText = errMessage;
      fieldError.classList.add("error");
      event.target.setCustomValidity(" ");
    }

  }

  setFieldValidity() {
    const self = this;
    this.domRoot.querySelectorAll(".required").forEach(requirement => {
      if (requirement.offsetParent
        && !requirement.hasMessageEventListener
        && requirement.type !== "checkbox"
        && requirement.type !== "email"
      ) {
        self.addRequiredAttribute(requirement);
      } else if (requirement.offsetParent == null && requirement.hasMessageEventListener) {
        self.removeRequiredAttribute(requirement);
      }
    });
  }

  removeRequiredAttribute(targetElement: HTMLInputElement) {
    targetElement.removeAttribute("required");
    targetElement.removeEventListener('invalid', (event) => {
      this.messageError(event);
    });
    ["keyup", "change"].forEach(eventType => {
      targetElement.removeEventListener(eventType, (event) => {
        this.clearError(event);
      });
    });
    targetElement.hasMessageEventListener = false;
  }

  addRequiredAttribute(targetElement: HTMLInputElement) {
    targetElement.setAttribute("required", "required");
    targetElement.addEventListener('invalid', (event) => {
      this.messageError(event);
    });
    ["keyup", "change"].forEach(eventType => {
      targetElement.addEventListener(eventType, (event) => {
        this.clearError(event);
      });
    });
    targetElement.hasMessageEventListener = true;
  }

  setFieldValidityForCheckBoxes() {
    const self = this;
    self.domRoot.querySelectorAll('fieldSet .checkbox input.required')
      .forEach((element: HTMLInputElement) => {
        const requiredInputsParentElement = element.offsetParent;
        if (requiredInputsParentElement && !element.hasMessageEventListener) {
          self.addRequiredAttribute(element);
        }
        requiredInputsParentElement!.addEventListener('change', (e) => {
          const targetInputElement = e.target as HTMLInputElement;
          const allCheckedInputs = requiredInputsParentElement?.querySelectorAll('input:checked');
          if (targetInputElement.checked) {
            self.removeRequiredAttribute(element);
            self.addRequiredAttribute(targetInputElement);
          } else {
            /**
             * If check is false, remove the targetINputElement's requried Attribute field
             * ...and if there are no more checked inputs then
             * add required attribute back to original required element
             */
            self.removeRequiredAttribute(targetInputElement);
            if (allCheckedInputs && allCheckedInputs.length < 1) {
              self.addRequiredAttribute(element);
            }
          }
          self.checkFormValidity();
        })
      });
  }

  setEmailFieldValidity() {
    const self = this;
    self.emailFields.forEach((element: any) => {
      element.setAttribute("required", "required");
      let elementPattern = element?.pattern;
      ["keyup", "change"].forEach(eventType => {
          element.addEventListener(eventType, (event: any) => {
            event.preventDefault();
            if (!elementPattern) {
              elementPattern = this.isBusinessDomainOnly ? defaultBusinessEmailPattern : defaultEmailPattern;
            }
            const regexTest = new RegExp(elementPattern).test(event.target.value);
            if (regexTest) {
              self.clearError(event);
            } else {
              self.messageError(event, true);
            }
          });
      });
      element.hasMessageEventListener = true;
    });
  }

  clearForm() {
    this.contactForms.forEach(form => form.reset())
  }

  getFormVals(form, serialize) {
    let obj = {};
    var array = [];
    let intercomMapping = {};
    [...form.elements].forEach(item => {
      let individual = {};
      let key = item.dataset.key;
      if (item.type == "email") {
        item.value = item.value.toLowerCase()
      }
      if (item.type == "number") {
        item.value = Number(item.value);
      }
      if (key && (item.offsetParent || item.tagName == "BUTTON")) {
        if (item.type == "radio" && item.checked) {
          obj[key] = item.value;
          individual.name = key;
          individual.value = item.value;
        } else if (item.type == "checkbox" && item.checked) {
          if (obj[key]) {
            obj[key] = obj[key] + ',' + item.dataset.localizedValue;
            individual.value = individual.value + ',' + item.dataset.localizedValue;
          } else {
            obj[key] = item.dataset.localizedValue;
            individual.value = item.dataset.localizedValue;
          }
          individual.name = key;
        } else if (item.type !== "radio" && item.type !== "checkbox" && item.tagName !== "BUTTON" ||
          (item.tagName == "BUTTON" && item.getAttribute("aria-selected") == "true")) {
          let textFieldValue = item.value.replace(/</g, '＜').replace(/>/g, '＞')
          // salesforce rejects < & > characters but we want users to still be able to enter them
          obj[key] = textFieldValue;
          individual.name = key;
          individual.value = textFieldValue;
        }
        array.push(individual);
      }

      if (Object.prototype.hasOwnProperty.call(item.dataset, 'intercomMapping')) {
        const itercomMappingKey = item.dataset.intercomMapping.toLowerCase();
        intercomMapping[itercomMappingKey] = item.dataset.key;
      }
    });
    obj['intercomMapping'] = intercomMapping;

    return serialize ? array : obj;
  }

  getCookie(name: string) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return '';
  }

  getSubscriberDetails(form) {
    let formData = this.getFormVals(form, true);
    return formData.reduce((acc, field) => {
      if (field.name !== 'email' && field.name !== 'list_name') {
        acc[field.name] = field.value;
      }
      return acc;
    }, {});
  }

  submitSuccess(data, state) {
    if (state.postSubmission == "Redirect") {
      window.location.href = state.redirect + window.location.search;
    } else {
      state.mainFormContainer.style.display = 'none';
      state.postSubmitMessage.style.display = 'block';
    }
    tracking.trackEvent('ConsentHub Submit', {
      "success": true,
      "event": "Submitted",
      "eventComponent": "Contact Sales Form"
    });
  }

  submitFailure(data, state) {
    state.activeForm.querySelector('.post-submit').innerHTML = state.params.errorSubmit;
    tracking.trackEvent('ConsentHub Submit', {
      "success": false,
      "event": "Failed",
      "eventComponent": "Contact Sales Form",
      "error-message": data
    });
  }

  sendToStreamhub(formValues) {
    let currentTime = new Date();
    let random = Math.round(Math.random() * 10000);

    let streamHubInfo = {
      "gmoiLocale": this.consentConfigInfo.locale,
      "formType": this.typeOfForm ? this.typeOfForm.value : this.availableFormTypeLabels[0],
      "formDef": this.formDef,
      "formSubmissionId": random + currentTime.getTime(),
      "created_at": currentTime,
      "marketoCookieId": this.getCookie('_mkto_trk'),
      "anonymousId": this.getCookie('ajs_anonymous_id').replace(/%22/g, ''),
      "atlassianId": this.getCookie('ajs_user_id').replace(/%22/g, ''),
      "submitted": currentTime.toString(),
      "source_sequence": currentTime.getTime(),
      "userAgent": window.navigator.userAgent,
      "isIntercomTracking": this.isIntercomTracking,
      "intercomAppId": this.intercomAppId.trim().toLowerCase()
    };
    const payLoad = Object.assign(formValues, streamHubInfo);
    postObjectToStreamhubContact(
      payLoad,
      this.submitTo,
      this.submitSuccess,
      this.submitFailure, this);
  }

  consenthubFailure(error) {
    tracking.trackEvent('ConsentHub Submit', {
      "success": false,
      "event": "Failed",
      "eventComponent": "ConsentHub Submit",
      "error-message": error
    });
    this.submitFailure(error, this);
  }

  formSubmitListener() {
    this.contactForms.forEach(contactForm => {
      let honeyPot = this.activeForm.querySelector('.email_hp');

      contactForm.addEventListener("submit", (event: SubmitEvent) => {
        event.preventDefault();
        if (honeyPot.value === "" && this.activeForm.checkValidity()) {
          let buttonSubmit = this.activeForm.querySelector('[type="submit"]');
          buttonSubmit.classList.add('loading', 'disabled');
          let formValues = this.getFormVals(contactForm);
          let consentHelperObj = {
            gdprId: contactForm.querySelector('.consent-checkbox') ? contactForm.querySelector('.consent-checkbox').id : this.params.gdprId,
            consentLabel: this.consentCheckboxText,
            email: formValues.email,
            formId: this.formId,
            formUrl: window.location.href,
            privacyPolicy: this.privacyPolicyText,
            paramsLocale: this.consentConfigInfo.locale,
            site: "atlassian"
          };

          this.consentHelper = new ConsentHelper(consentHelperObj, contactForm);
          this.consentHelper.submitForm(() => {
            this.sendToStreamhub(formValues)
          }, (error) => {
            this.consenthubFailure(error);
          });
        }
      });
    })
  }

  showCheckbox() {
    this.consents.forEach(consent => {
      consent.style.display = "flex";
    })
  }

  hideCheckboxAndConsent() {
    this.consentCheckboxes.forEach(consentCheckbox => {
      consentCheckbox.checked = true;
    })
  }

  getConsentInfo() {
    this.ConsentHub.requestConfig()
      .then(config => {
        this.consentConfigInfo = config;
        if (config.localeRequiresMarketingCommunicationOptIn) {
          this.showCheckbox();
        } else {
          this.hideCheckboxAndConsent();
        }
      })
      .catch(() => {
        this.showCheckbox();
      })
  }

  async getUserData() {
    const apiUrl = Environment.getAPIPrivateURL();
    const data = await fetch(`${apiUrl}/me`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        }
      })
      .then((res) => res.json())
      .catch();

    if (data && data.email) {
      
      const emailFields = this.domRoot.querySelectorAll("input[type='email']");
      if (emailFields.length) {
        emailFields[0].value = data.email;
      }
    }
  }

  setConditionalDisplays(conditionalType, conditionalValue, hide) {
    const conditionals = Array.from(this.domRoot.querySelectorAll(`.${conditionalType}-conditional`));
    conditionals.forEach(condition => {
      if (hide) {
        condition.style.display = "none";
      } else if (condition.classList.contains(conditionalValue)) {
        condition.style.display = "flex";
      } else {
        condition.style.display = "none";
      }
    });
    this.setFieldValidity()
  }

}
